import { $user, $form, $view } from 'signals/global.signals';
import { handleHideModal } from 'components/global/_helpers/global.helpers';
import { handleSubmitAddToPipeline } from 'components/views/PublicRoom/_helpers/publicRoom.events';
import { PIPELINE_STATUS_OPTIONS, RATINGS_OPTIONS } from 'constants/globalConstants';
import SimpleModal from 'components/global/SimpleModal';
import UniversalInput from 'components/global/UniversalInput/UniversalInput';

const PublicRoomAddToPipelineModal = ({ dealId }) => (
  <SimpleModal
    show={$view.value.activeModal === 'add-to-pipeline'}
    title="Add Deal"
    isLoading={$view.value?.isModalLoading}
    onHide={handleHideModal}
    onPrimaryClick={() => handleSubmitAddToPipeline(dealId)}
    primaryButtonText="Add to pipeline"
    isPrimaryButtonDisabled={
      ($user.value.organization?.investorOrg?.investorType === 'Angel'
        ? !$form.value.rating
        : !$form.value.teamId || !$form.value.rating) || !$form.value.status
    }
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
  >
    <p>Add this deal to you and your team&apos;s pipeline.</p>
    {$user.value.organization?.investorOrg?.investorType !== 'Angel' && (
      <UniversalInput
        type="select"
        name="teamId"
        value={$form.value.teamId}
        options={$view.value.teamOptions}
        placeholder="Select Team"
      />
    )}
    <UniversalInput
      type="select"
      name="rating"
      options={RATINGS_OPTIONS}
      placeholder="Select Deal Rating"
    />
    <UniversalInput
      type="select"
      name="status"
      options={PIPELINE_STATUS_OPTIONS}
      placeholder="Select Deal Status"
    />
  </SimpleModal>
);

export default PublicRoomAddToPipelineModal;
